import { ScrollContainer } from 'foundations-components/transitional/components/ScrollContainer';
import { jsx as _jsx } from "react/jsx-runtime";
const MaybeScrollingContainer = ({
  children,
  shouldScroll,
  showScrollOverhangs = false,
  scrollContainerSelector
}) => {
  if (shouldScroll) {
    return /*#__PURE__*/_jsx(ScrollContainer
    // Setting size to 0 removes the shaded overhang on the top and bottom of the scrollable area
    , {
      size: showScrollOverhangs ? undefined : 0,
      blockSize: "100%",
      inlineSize: "100%",
      "data-scroll-container": scrollContainerSelector || 'true',
      children: children
    });
  }
  return /*#__PURE__*/_jsx("div", {
    style: {
      height: '100%',
      width: '100%'
    },
    children: children
  });
};
export default MaybeScrollingContainer;